module.exports = __webpack_public_path__ + "static/media/dryer-alt.ef24ba8f.svg";